export const STANDARD_DAS_TEXT
  = 'No primary research results, software or code have been included and no new data were generated or analysed as part of this review.'
